import { Component, OnInit } from '@angular/core';
import { AuthenticationService,DashboardService, ProfileService,CompanyService, AlertService,SurveyService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router"

/* declare var google:any; */
declare var google:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  private authorized:any;
  public param:any;
  public profile:any;
  public business:any;
  public companyId:any='';
  public dashboard:any;
  public surveys:any;
  public a:any;
  constructor(
    public profileService: ProfileService,
    public companyService:CompanyService,
    public surveyService:SurveyService,
    public dashboardService:DashboardService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) {
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
  }

  ngOnInit() {

    this.profileService.cast.subscribe(response => {
      this.profile = response;
      if(this.profile && this.profile.role.name == "root" || this.profile && this.profile.role.name == "super"){
        this.getDashboard('');
        this.companyService.getBussiness({page:1,offset:100,orderby:"[['name','ASC']]"}).subscribe(response => {
            this.business = response;
        }, error => {
        })
      }
    }, error => {
    })
    
  }
  getDashboard(data){
    this.dashboard=null;
    this.dashboardService.getDashboard(data).subscribe(response => {
      this.dashboard = response;
      google.charts.load("current", {packages:['corechart']});
      google.charts.setOnLoadCallback(this.drawChart);
    }, error => {
    })
  }
  drawChart = () =>  {
    if(this.dashboard[0]){
      var data = google.visualization.arrayToDataTable(this.dashboard[0].data);
      var view = new google.visualization.DataView(data);
      var chart = new google.visualization[this.dashboard[0].chartType](document.getElementById("columnchart_values"));
      chart.draw(view, this.dashboard[0].options);
    }
    if(this.dashboard[1]){
      var data1 = google.visualization.arrayToDataTable(this.dashboard[1].data);
      var view1 = new google.visualization.DataView(data1);
      var chart1 = new google.visualization[this.dashboard[1].chartType](document.getElementById("columnchart_values1"));
      chart1.draw(view1, this.dashboard[1].options);
    }
    if(this.dashboard[2]){
      var data2 = google.visualization.arrayToDataTable(this.dashboard[2].data);
      var view2 = new google.visualization.DataView(data2);
      var chart2 = new google.visualization[this.dashboard[2].chartType](document.getElementById("columnchart_values2"));
      chart2.draw(view2, this.dashboard[2].options);
    }
  }
  url(path){
    this.router.navigate([path]);
  }
}
